import React from "react";
import { PageCanvas } from "../../../layouts/PageCanvas";
import { PageContainer } from "../../../layouts/PageContainer";
import { PageHeader } from "../../../layouts/PageHeader";
import SupportSettings from "./SupportSettings";

interface IProps {}

const PageSettingsSupport = (props: IProps) => {
  return (
    <PageContainer>
      <PageHeader title={"Support"} isIncludeProfile={true}></PageHeader>
      <PageCanvas px={"4"} py={8}>
        <SupportSettings />
      </PageCanvas>
    </PageContainer>
  );
};

export default PageSettingsSupport;
